<template>
  <div>
    <!-- 条件搜索 -->
    <div class="b-conditions-style">
      <div class="b-con-form">
        <el-checkbox label="仅看重复进线" class="yorker-only-repeat" :true-label="1" :false-label="0" v-model="condition.has_repeat" @change="search"></el-checkbox>
      </div>
      <div class="b-con-form">
        <label class="c-label">客户手机号</label>
        <el-input class="b-con-filter-area" v-model="condition.contact_tel" placeholder="请输入" clearable ></el-input>
      </div>
      <div class="b-con-form">
        <label class="c-label">分配方式</label>
        <el-select class="b-con-filter-area" placeholder="请选择" v-model="condition.type" clearable>
          <el-option label="全部" value=""></el-option>
          <el-option v-for="(o, i) in options.distribute_log_type" :key="i" :label="o" :value="i"></el-option>
        </el-select>
      </div>
      <div class="c-con-search-btn">
        <button class="global-btn primary size-1" @click="search">搜索</button>
        <button class="global-btn primary-round size-1" @click="searchMore">搜索更多</button>
      </div>
    </div>
    <div class="b-inner-menus b-inner-menus-dist" v-if="userInfo.is_no_secret_login != 1">
      <div class="b-inner-flex">
        <p class="b-i-menu" @click="downloadByCondition">
          <i class="iconfont iconhebing b-i-icon"></i>
          <span>导出</span>
        </p>
      </div>
    </div>
    <cu-table :data="list" :pageData="pageData" :isLoading="isLoading" @currentChange="currentChange" @sort-change="handleSort" class="cu-table-normal-height">
      <el-table-column label="客户姓名" min-width="150" fixed="left">
        <p slot-scope="scope" class="b-c-ellipse b-c-cursor" :title="scope.row.contact_name" @click="toCustomeDetail(scope.row)">{{scope.row.contact_name || '--'}}</p>
      </el-table-column>
      <el-table-column label="手机号码" min-width="150">
        <p slot-scope="scope" class="b-c-ellipse" :title="scope.row.contact_tel">{{scope.row.contact_tel || '--'}}</p>
      </el-table-column>
      <el-table-column label="进线时间" min-width="180">
        <template slot="header">  
          <span>
            进线时间
            <el-tooltip
               class="item"
               effect="dark"
               placement="top-start"
            >
              <i class="el-icon-warning"></i>
              <div slot="content" style="width:300px;">
                <p>次数：指号码重复进线后有产生归属变更的次数（即新客池自动归属、公客池自动唤醒、无效池自动唤醒）</p>
                <p>时间：指本次进线的时间</p>
              </div>
            </el-tooltip>
          </span>
        </template>
        <template slot-scope="scope">
          <p>第{{scope.row.repeat_times || 0}}次</p>
          <p v-analysis-time:all="scope.row.incoming_time"></p>
        </template>
      </el-table-column>
      <el-table-column label="来源" min-width="200">
        <p slot-scope="scope" class="b-c-ellipse" :title="scope.row.source_total_string">{{scope.row.source_total_string || '--'}}</p>
      </el-table-column>
      <el-table-column label="分配方式" min-width="150">
        <p slot-scope="scope" class="b-c-ellipse" :title="scope.row.type_name">{{scope.row.type_name || '--'}}</p>
      </el-table-column>
      <el-table-column label="分配人" min-width="150">
        <p slot-scope="scope" class="b-c-ellipse">{{scope.row.handler_name || '--'}}</p>
      </el-table-column>
      <el-table-column label="被分配人" min-width="150">
        <p slot-scope="scope" class="b-c-ellipse">{{scope.row.owner_name || '--'}}</p>
      </el-table-column>
      <el-table-column label="分配时间" min-width="180" prop="created_at" sortable>
        <p slot-scope="scope" class="b-c-ellipse">{{scope.row.created_at || '--'}}</p>
      </el-table-column>
      <el-table-column label="客户创建时间" min-width="180" prop="customer_created_at">
        <p slot-scope="scope" class="b-c-ellipse" v-analysis-time:all="scope.row.customer_created_at"></p>
      </el-table-column>
    </cu-table>

    <yorker-condition v-bind:isOpen.sync="isOpenMore" ref="moreConditionRef" @comfirmCheck="confirmMore" @reset="handleReset" />
  </div>
</template>
<script>
import {getYorkerRecordeList, exportYorkerRecord} from '@/api/custome';
import CuTable from '@/components/cTable';
import {configKeys} from '@/setting/index';
import { mapState } from 'vuex';
import { validateMobileReg } from '@/utils/validate';
import YorkerCondition from  './component/conditionMore';
export default{
  name: 'YorkerRecorde',
  components: {
    CuTable,
    YorkerCondition
  },
  data () {
    return {
      options: {},
      condition: {
        contact_tel: '',
        type: '',
        has_repeat: 0
      },
      list: [],
      isLoading: false,
      isOpenMore: false,
      pageData: {
        per_page: 10,
        page: 1,
        total: 0
      }
    }
  },
  computed: {
    ...mapState({
      emitName: state => state.const.emitName,
      userInfo: state => state.user.userInfo
    })
  },
  async created() {
    this.initRecordList();
    this.options = await this.$store.dispatch('initConfig', [configKeys.distribute_log_type]);
  },
  methods: {
    async initRecordList () {
      this.isLoading = true;
      try {
        const params = {
          ...this.pageData,
          ...this.condition
        }
        if (params.owner_admin_id < 0) params.owner_admin_id = 0;
        if (params.contact_tel && !validateMobileReg(params.contact_tel)) {
          this.$message.error('请输入正确的手机号格式');
          return null;
        }
        const res = await getYorkerRecordeList(params);
        this.list = res.data ?? [];
        this.$set(this.pageData, 'total', res.total);
      } catch (error) {
        this.$message.error(error.msg || '操作失败，请重试');
      } finally {
        this.isLoading = false;
      }
    },
    currentChange (page) {
      this.pageData.page = page;
      this.initRecordList();
    },
    handleSort (item) {
      this.condition.order_field = item.prop;
      this.condition.order_type = item.order === "ascending" ? 'asc' : 'desc';
      this.initRecordList();
    },
    toCustomeDetail (row) {
      this.$EventBus.$emit(this.emitName, {category: 'customerDetail', params: {
        customerId: row.customer_id
      }});
    },
    search () {
      this.pageData.page = 1;
      this.initRecordList();
    },
    searchMore () {
      this.isOpenMore = true;
      this.$refs?.moreConditionRef?.changeParams(this.condition);
    },
    confirmMore (data) {
      this.condition = {...data};
      this.search();
    },
    handleReset (data) {
      this.condition = {
        ...data,
        has_repeat: 0,
        contact_tel: '',
        type: ''
      }
      this.createTimeList = [];
      this.search();
    },
    async downloadByCondition () {
      if (this.pageData.total === 0) {
        this.$message.error('没有可导出的数据');
        return null;
      }
      try {
        const params = {};
        Object.keys(this.condition).map(v => {
          if (this.condition[v] !== '') {
            const value = v == 'owner_admin_id' ? this.condition[v] < 0 ? 0 : this.condition[v] : this.condition[v];
            params[v] = value;
          }
        })
        await exportYorkerRecord(params);
        this.$EventBus.$emit(`importAnimate`, 1);
      } catch (error) {
        this.$message.error(error.msg || '操作失败，请重试');
      }
    }
  },
}
</script>
<style lang="less">
@import url('~@/assets/style/base/search.less');
.yorker-only-repeat{
  .el-checkbox__label{
    font-size: 12px;
    color: #666666;
  }
}
</style>